/* © CNES */
import { Card } from 'primereact/card';
import './MapViewContainer.scss';

/**
 * MapViewContainer displays several Map on screen.
 * @param provider provider of map
 * @param links links links to map
 * @param label label of map
 * @param clickFunction Function handle click on map for selection
 * @returns MapViewContainer Element.
 */
export const MapViewContainer = ({
  provider,
  links,
  label,
  clickFunction,
}: {
  links: Array<string>;
  provider: string;
  label: string;
  clickFunction: Function;
}) => {
  return (
    <>
      <Card
        className="cardMaps"
        aria-label="cardMaps"
        onClick={() => clickFunction()}
      >
        <div className="map-preview-large-scale">
          {links.map((link) => (
            <img
              src={link}
              alt="background map preview part"
              className="picture"
              key={link}
            />
          ))}
        </div>
        <div className="titleMap">
          <p>{label}</p>
          <p className="provider">{provider}</p>
        </div>
      </Card>
    </>
  );
};
